import { ShieldCheck, Star, MessageCircle, Briefcase, Building2 } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { PageCTA } from "../components/PageCTA";
import { Reveal, Overline } from "../components/Reveal";
import { useLang } from "../context/LanguageContext";

const HERO_IMG = "https://images.unsplash.com/photo-1634549709262-508c47d4c229";
const WHY_ICONS = [Star, ShieldCheck, MessageCircle];
const ITEM_ICONS = [Building2, Briefcase];

export default function Services() {
  const { t } = useLang();
  const s = t.pages.services;

  return (
    <div data-testid="services-page">
      <PageHero overline={s.overline} title={s.title} subtitle={s.subtitle} image={HERO_IMG} />

      <section className="relative z-10 py-20 md:py-28 bg-[#050505]">
        <div className="max-w-7xl mx-auto px-6">
          <Reveal>
            <Overline>{s.subtitle}</Overline>
          </Reveal>
          <div className="grid md:grid-cols-1 gap-px mt-8 bg-white/10">
            {s.items.map((item, i) => {
              const Icon = ITEM_ICONS[i];
              return (
                <Reveal key={i} delay={i * 0.12}>
                  <div className="group h-full bg-[#0a0a0a] p-10 md:p-12 hover:bg-[#111] transition-colors duration-500">
                    <div className="w-14 h-14 flex items-center justify-center border border-[#D4AF37]/40 text-[#D4AF37] mb-8 group-hover:bg-[#D4AF37] group-hover:text-black transition-colors duration-500">
                      <Icon size={24} strokeWidth={1.5} />
                    </div>
                    <h3 className="font-display text-2xl md:text-3xl mb-4">{item.title}</h3>
                    <p className="text-white/55 leading-relaxed">{item.text}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <section className="relative z-10 py-20 md:py-28 bg-[#0a0a0a] border-y border-white/5">
        <div className="max-w-7xl mx-auto px-6">
          <Reveal>
            <h2 className="font-display text-4xl md:text-5xl tracking-tight">{s.whyTitle}</h2>
          </Reveal>
          <div className="grid md:grid-cols-3 gap-8 mt-14">
            {s.why.map((w, i) => {
              const Icon = WHY_ICONS[i];
              return (
                <Reveal key={i} delay={i * 0.12}>
                  <div className="h-full border border-white/10 hover:border-[#D4AF37]/50 transition-colors duration-300 p-8">
                    <Icon size={26} className="text-[#D4AF37] mb-6" strokeWidth={1.5} />
                    <h3 className="font-display text-2xl mb-3">{w.title}</h3>
                    <p className="text-white/55 leading-relaxed">{w.text}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <PageCTA label={t.pages.common.consultation} />
    </div>
  );
}
